import React from 'react';
import { IndexRoute, Route } from 'react-router';
import StatementBuyPoints from './statementBuyPoints';

export default (
  <Route path="statement-buy-points">
    <IndexRoute component={props => <StatementBuyPoints {...props} />} />
  </Route>
);
